<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <h5>Potentiële matches</h5>
      <div>
        <a-button v-if="toggleBulkActions" class="mx-2" type="primary" @click="bulkApproveMatches">Geselecteerde goedkeuren</a-button>
        <a-button v-if="toggleBulkActions" class="mx-2" type="danger" @click="bulkRejectMatches">Geselecteerde afkeuren</a-button>

        Bulk acties
        <a-switch class="mx-2" @change="toggleBulkActions = !toggleBulkActions" :checked="toggleBulkActions"></a-switch>

      </div>
    </div>
    <hr/>
    <a-list item-layout="horizontal" :loading="loading" :data-source="potentialMatches">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-button v-if="!toggleBulkActions" type="primary" slot="actions" @click="approveMatch(item)">Goedkeuren</a-button>
        <a-button v-if="!toggleBulkActions" type="danger" slot="actions" @click="rejectMatch(item)">Afkeuren</a-button>
        <a-checkbox v-if="toggleBulkActions" slot="actions" :checked="item.is_checked" @change="item.is_checked = !item.is_checked">Selecteer</a-checkbox>

        <div class="flex-grow-1 overflow-auto">
          <table class="table table-striped text-successtable-border border-light">
            <thead class="border-light">
              <tr>
                <th scope="col"></th>
                <th scope="col"><strong>Factuur</strong></th>
                <th scope="col"><strong>Banktransactie</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Reden van match</th>
                <td colspan='2'>{{ item.match_reason === "Possible match based on amount" ? "Mogelijke match op basis van bedrag" : "Mogelijke match op basis van omschrijving" }}</td>
              </tr>
              <tr>
                <th scope="row">Factuurnummer / Banktransactie</th>
                <td>{{ item.invoice.invoice_number }}</td>
                <td>{{ item.camt_transaction.description }}</td>
              </tr>
              <tr>
                <th scope="row">Bedrijfsnaam+Afdeling / Rekeningnaam</th>
                <td>{{ item.full_organization_name }}</td>
                <td>{{ item.camt_transaction.name }}</td>
              </tr>
              <tr>
                <th scope="row">Factuur totaal / Transactiebedrag</th>
                <td>{{ item.invoice_total }}</td>
                <td>{{ item.camt_transaction.amount }}</td>
              </tr>
              <tr>
                <th scope="row">Factuur Aanmaakdatum / Transactiedatum</th>
                <td>{{ item.invoice.generated_at }}</td>
                <td>{{ item.camt_transaction.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      potentialMatches: [],
      loading: true,
      toggleBulkActions: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  mounted() {
    this.fetchPotentialMatches()
  },
  methods: {
    fetchPotentialMatches() {
      this.$axios
        .get('/bookkeeping/camt/match/potential', {
          headers: {
            Authorization: `Bearer ${this.user.user.token}`,
          },
        })
        .then((response) => {
          this.potentialMatches = response.data.map((item) => {
            return {
              ...item,
              is_checked: false,
            }
          })
          this.loading = false
        })
        .catch((error) => {
          console.error('Error fetching potential matches:', error)
        })
    },
    approveMatch(item) {
      this.loading = true
      this.$axios
        .post('/bookkeeping/camt/match/approve', {
          potential_invoice_match_id: item.id,
        }, {
          headers: {
            Authorization: `Bearer ${this.user.user.token}`,
          },
        })
        .then((response) => {
          console.log('Match approved:', response.data)
          this.fetchPotentialMatches()
        })
        .catch((error) => {
          console.error('Error approving match:', error)
        })
    },
    rejectMatch(item) {
      this.loading = true
      this.$axios
        .post('/bookkeeping/camt/match/reject', {
          potential_invoice_match_id: item.id,
        }, {
          headers: {
            Authorization: `Bearer ${this.user.user.token}`,
          },
        })
        .then((response) => {
          console.log('Match rejected:', response.data)
          this.fetchPotentialMatches()
        })
        .catch((error) => {
          console.error('Error rejecting match:', error)
        })
    },
    bulkApproveMatches() {
      const selectedMatches = this.potentialMatches.filter(item => item.is_checked).map(item => item.id)
      if (selectedMatches.length === 0) {
        alert('Selecteer tenminste één match om goed te keuren.')
        return
      }
      this.loading = true
      this.$axios
        .post('/bookkeeping/camt/match/approve/bulk', {
          potential_invoice_match_ids: selectedMatches,
        }, {
          headers: {
            Authorization: `Bearer ${this.user.user.token}`,
          },
        })
        .then((response) => {
          console.log('Bulk approve response:', response.data)
          this.fetchPotentialMatches()
        })
        .catch((error) => {
          console.error('Error bulk approving matches:', error)
        })
    },
    bulkRejectMatches() {
      const selectedMatches = this.potentialMatches.filter(item => item.is_checked).map(item => item.id)
      if (selectedMatches.length === 0) {
        alert('Selecteer tenminste één match om af te keuren.')
        return
      }
      this.loading = true
      this.$axios
        .post('/bookkeeping/camt/match/reject/bulk', {
          potential_invoice_match_ids: selectedMatches,
        }, {
          headers: {
            Authorization: `Bearer ${this.user.user.token}`,
          },
        })
        .then((response) => {
          console.log('Bulk reject response:', response.data)
          this.fetchPotentialMatches()
        })
        .catch((error) => {
          console.error('Error bulk rejecting matches:', error)
        })
    },
  },
}
</script>
